import i18n from '../i18n';

/**
 * Format last seen date/time
 * @param {Date|string} date - Last seen date
 * @returns {string} Formatted string:
 *   - "Last seen today HH:MM" if today
 *   - "Last seen yesterday HH:MM" if yesterday
 *   - "Last seen DD.MM.YYYY" if older
 */
export const formatLastSeen = (date) => {
  if (!date) return '';
  
  try {
    // Ensure date is a valid Date object or string
    if (typeof date === 'object' && !(date instanceof Date)) {
      // If it's an object but not a Date, try to convert
      if (date.toString && typeof date.toString === 'function') {
        date = date.toString();
      } else {
        return '';
      }
    }
    
    const now = new Date();
    const last = new Date(date);
    
    // Check if date is valid
    if (!last || isNaN(last.getTime())) {
      return '';
    }

    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const lastDate = new Date(
      last.getFullYear(),
      last.getMonth(),
      last.getDate()
    );

    const time = last.toLocaleTimeString(i18n.language, {
      hour: '2-digit',
      minute: '2-digit'
    });

    // Ensure time is a string
    if (typeof time !== 'string') {
      return '';
    }

    if (lastDate.getTime() === today.getTime()) {
      return i18n.t('shared:lastSeen.today', { time });
    }

    if (lastDate.getTime() === yesterday.getTime()) {
      return i18n.t('shared:lastSeen.yesterday', { time });
    }

    const dateString = last.toLocaleDateString(i18n.language);
    // Ensure dateString is a string
    if (typeof dateString !== 'string') {
      return '';
    }

    return i18n.t('shared:lastSeen.older', { date: dateString });
  } catch (error) {
    // Silently fail, don't log to avoid console spam
    return '';
  }
};

